import { useState, useEffect } from 'react';
import UploadTerm from './UploadWindows/UploadTerm';
import UploadSiteDetail from './UploadWindows/UploadSiteDetail';
import UploadProjectDetail from './UploadWindows/UploadProjectDetail';
import UploadPatientSite from './UploadWindows/UploadPatientSite';
import UploadDataPatient from './UploadWindows/UploadDataPatient';
import UploadSummaryPatient from './UploadWindows/UploadSummaryPatient';
import UploadLoading from './UploadWindows/UploadLoading';
import UploadAddedToQueue from './UploadWindows/UploadAddedToQueue';
import UploadFormEntry from './UploadWindows/UploadFormEntry';
import { useUploadQueueProvider } from '../../../../Providers/UploadQueueProvider';
import { useUploadIntoQueueProvider } from '../../../../Providers/UploadIntoQueueProvider';
import { useUploadProcessProvider } from '../../../../Providers/UploadProcessProvider';
import { useEnvironmentVariablesProvider } from '../../../../Providers/EnvironmentVariablesProvider';

const UploadWindow = ({
}) => {
    // The data structure here is the doubly linked list use to traverse between different components
    const [toNextWindow, setToNextWindow] = useState(false);
    const [toPrevWindow, setToPrevWindow] = useState(false);
    const uploadQueueProvider = useUploadQueueProvider()
    const uploadIntoQueueProvider = useUploadIntoQueueProvider();
    const uploadProcessProvider = useUploadProcessProvider();
    const environmentVariablesProvider = useEnvironmentVariablesProvider()

    // Setting up the node for each component

    const UploadAddedToQueueNode = {
        value: <UploadAddedToQueue setToNextWindow={setToNextWindow} setToPrevWindow={setToPrevWindow} setOpenQueue={(uploadQueueProvider.queueLength === 1 && (uploadQueueProvider.queueStatus === "Hashing" || uploadQueueProvider.queueStatus === "Done" || uploadQueueProvider.queueStatus === "Uploading")) ? uploadIntoQueueProvider.setOpenLoading : uploadIntoQueueProvider.setOpenLoading(false)} />,
        previous: null,
        next: null,
        name: "UploadAddedToQueue"
    }

    const UploadLoadingNode = {
        value: <UploadLoading setToNextWindow={setToNextWindow} setToPrevWindow={setToPrevWindow} />,
        previous: null,
        next: null,
        name: "UploadLoading",
    }

    const UploadSummaryPatientNode = {
        value: <UploadSummaryPatient
            setToNextWindow={setToNextWindow}
            setToPrevWindow={setToPrevWindow} />,
        previous: null,
        next: null,
        name: "UploadSummaryPatient",
    }

    const UploadDataPatientNode = {
        value: <UploadDataPatient setToNextWindow={setToNextWindow} setToPrevWindow={setToPrevWindow} />,
        previous: null,
        next: null,
        name: "UploadDataPatient",
    }

    const UploadFormEntryNode = {
        value: <UploadFormEntry setToNextWindow={setToNextWindow} setToPrevWindow={setToPrevWindow} />,
        previous: null,
        next: null,
        name: "UploadFormEntry",
    }

    const UploadPatientSiteNode = {
        value: <UploadPatientSite setToPrevWindow={setToPrevWindow} setToNextWindow={setToNextWindow} />,
        previous: null,
        next: null,
        name: "UploadPatientSite",
    }

    const UploadSiteDetailNode = {
        value: <UploadSiteDetail setToNextWindow={setToNextWindow} setToPrevWindow={setToPrevWindow} />,
        previous: null,
        next: null,
        name: "UploadSiteDetail",
    }

    const UploadProjectDetailNode = {
        value: <UploadProjectDetail setToNextWindow={setToNextWindow} setToPrevWindow={setToPrevWindow} />,
        previous: null,
        next: null,
        name: "UploadProjectDetail",
    }

    const UploadTermNode = {
        value: <UploadTerm setToNextWindow={setToNextWindow} />,
        previous: null,
        next: null,
        name: "UploadTerm",
    }

    // Setting up the next and previous nodes for each window
    UploadTermNode.next = UploadSiteDetailNode;
    UploadSiteDetailNode.previous = UploadTermNode;
    UploadSiteDetailNode.next = UploadProjectDetailNode;
    UploadProjectDetailNode.previous = UploadSiteDetailNode;
    UploadProjectDetailNode.next = UploadPatientSiteNode;
    UploadPatientSiteNode.previous = UploadProjectDetailNode;
    UploadPatientSiteNode.next = UploadDataPatientNode;
    UploadDataPatientNode.previous = UploadPatientSiteNode;
    UploadDataPatientNode.next = UploadSummaryPatientNode;
    UploadSummaryPatientNode.previous = UploadDataPatientNode;
    UploadSummaryPatientNode.next = UploadAddedToQueueNode;
    UploadAddedToQueueNode.previous = UploadSummaryPatientNode
    UploadAddedToQueueNode.next = UploadLoadingNode;
    UploadLoadingNode.previous = UploadAddedToQueueNode;

    // Setting up the default node
    let defaultNode = UploadTermNode;

    // Case where PHI warning is turned on and form is enabled
    if (environmentVariablesProvider.environmentVariables.FORM) {
        UploadPatientSiteNode.next = UploadFormEntryNode;
        UploadFormEntryNode.previous = UploadPatientSiteNode;
        UploadFormEntryNode.next = UploadSummaryPatientNode;
        UploadSummaryPatientNode.previous = UploadFormEntryNode;
    }

    // Case where PHI warning is turned off
    if (!environmentVariablesProvider.environmentVariables.PHI_WARNING) {
        UploadSiteDetailNode.previous = null;
        defaultNode = UploadSiteDetailNode;
    }

    // The current window
    const [currentComponent, setCurrentComponent] = useState(defaultNode);

    // To open the Loading page from the queue
    useEffect(() => {
        if (uploadIntoQueueProvider.openLoading === true) {
            setCurrentComponent(UploadLoadingNode)
        }
        uploadIntoQueueProvider.setOpenLoading(false)
    }, [uploadIntoQueueProvider.openLoading])

    // Switch between the different components
    useEffect(() => {
        if (toNextWindow === true) {
            setCurrentComponent(currentComponent.next);
        }
        if (toPrevWindow === true) {
            setCurrentComponent(currentComponent.previous);
        }
        setToPrevWindow(false);
        setToNextWindow(false);
    }, [toNextWindow, toPrevWindow])


    return (
        <>
            <div style={{ marginTop: "5px" }}>
                {currentComponent.value}
            </div>
        </>
    );
}

export default UploadWindow;
